/**
 * Exibe toast quando o SW sinaliza nova versão; confirma com `/version.json` para evitar
 * falsos positivos (bundle desalinhado com o que o servidor já publicou).
 */

import { useEffect } from 'react'
import { isPublishedAppVersionNewer } from '@/shared/lib/appVersionCompare'
import { fetchRemoteAppVersion } from '@/shared/pwa/remoteAppVersion'
import { showPwaUpdateToast } from '@/shared/pwa/showPwaUpdateToast'
import { SW_NEED_REFRESH_EVENT, SW_NEED_REFRESH_FLAG } from './dispatchSwNeedRefresh'

export const SwRefreshPrompt = () => {
  useEffect(() => {
    let cancelled = false

    const handleRefresh = async () => {
      const remote = await fetchRemoteAppVersion()
      if (cancelled) return

      if (remote && !isPublishedAppVersionNewer(remote.version, __APP_VERSION__)) {
        sessionStorage.removeItem(SW_NEED_REFRESH_FLAG)
        return
      }

      sessionStorage.removeItem(SW_NEED_REFRESH_FLAG)
      showPwaUpdateToast()
    }

    const onEvent = () => {
      void handleRefresh()
    }

    window.addEventListener(SW_NEED_REFRESH_EVENT, onEvent)

    if (sessionStorage.getItem(SW_NEED_REFRESH_FLAG)) {
      void handleRefresh()
    }

    return () => {
      cancelled = true
      window.removeEventListener(SW_NEED_REFRESH_EVENT, onEvent)
    }
  }, [])

  return null
}
